var render = function () {
  var _ref, _vm$currentRound, _vm$currentRound2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "steps-container"
  }, [_c('div', {
    ref: "imageHolder",
    staticClass: "image-holder",
    attrs: {
      "id": "image-holder"
    }
  }), !!_vm.currentStep ? _c('div', {
    staticClass: "step"
  }, [_vm.isCompleteWordStep ? _c('div', {
    staticClass: "td-holder",
    attrs: {
      "transition": "fade"
    }
  }, [_c('div', {
    staticClass: "big-wrap bigText",
    attrs: {
      "id": ("section-" + (_vm.currentStep.id))
    }
  }, [_c('color-block-text', {
    attrs: {
      "is-simple": true,
      "text": _vm.currentRound.word,
      "answer": _vm.currentRound.letterCombo,
      "text-step": (_ref = ((_vm$currentRound = _vm.currentRound) === null || _vm$currentRound === void 0 ? void 0 : _vm$currentRound.repetitions) - 1) !== null && _ref !== void 0 ? _ref : 5
    }
  })], 1)]) : _vm._e(), _c('div', {
    staticClass: "td-holder",
    attrs: {
      "transition": "fade"
    }
  }, _vm._l((_vm$currentRound2 = _vm.currentRound) === null || _vm$currentRound2 === void 0 ? void 0 : _vm$currentRound2.steps, function (step, index) {
    return _c('div', {
      key: step.id,
      staticClass: "normal-wrap normalText",
      attrs: {
        "id": ("section-" + (step.id))
      }
    }, [_c('color-block-text', {
      attrs: {
        "is-simple": true,
        "text": step.answer,
        "text-step": index
      }
    })], 1);
  }), 0)]) : _vm._e(), _c('article', {
    class: {
      'curtain-container': true,
      isMobile: _vm.isMobile
    }
  }, [_c('div', {
    staticClass: "curtain"
  })])])])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }